jQuery(document).ready(function () {
    const buttonsCenter = document.querySelector('.buttons-center');
    const video = document.querySelector('.video-section video');
    const play = document.querySelector('.play');
    const pause = document.querySelector('.pause');
    const fs = document.querySelector('.img-container--fullscreen');
    const fsMobile = document.querySelector('.fs-mobile');
    const unmute = document.querySelector('.unmute');
    const mute = document.querySelector('.mute');
    const toggleAudio = document.querySelector('.img-container--toggle-audio');

    const videoWidth = parseInt(getComputedStyle(video).width);

    if (video.webkitEnterFullscreen) { /* Safari */
        video.removeAttribute('controls');
    } else if (video.msRequestFullscreen) { /* IE11 */
        video.removeAttribute('controls');
    } else if (video.requestFullscreen) {
        video.removeAttribute('controls');
    }

    function openFullscreen() {
        if (video.webkitEnterFullscreen) { /* Safari */
            video.webkitEnterFullscreen();
        } else if (video.msRequestFullscreen) { /* IE11 */
            video.msRequestFullscreen();
        } else if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen;
        }
    }

    // mute, gdy wychodzimy z fullscreena na wideo

    let resizeObserver = new ResizeObserver(entries =>
    {
        for (let entry of entries)
        {
            if(parseInt(getComputedStyle(video).width) === videoWidth) {
                video.muted = true;
            }
        }
    });

    resizeObserver.observe(video);

    buttonsCenter.addEventListener('click', () => {
        video.muted = false;
        openFullscreen();
        mute.classList.add('shown');
        unmute.classList.remove('shown');
        video.currentTime = 0;

    });

    fs.addEventListener('click', () => {
        openFullscreen();
    });

    toggleAudio.addEventListener('click', () => {
        if(video.muted === false) {
            video.muted = true;
            mute.classList.remove('shown');
            unmute.classList.add('shown');
        } else {
            video.muted = false;
            mute.classList.add('shown');
            unmute.classList.remove('shown');
        }
    });


})